"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { DayPicker, type DayButton, type Locale } from "react-day-picker";
import { cn } from "../utils";
function CalendarDayButton(t0) {
  const $ = _c(22);
  let className;
  let day;
  let locale;
  let modifiers;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      day,
      modifiers,
      locale,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = day;
    $[3] = locale;
    $[4] = modifiers;
    $[5] = props;
  } else {
    className = $[1];
    day = $[2];
    locale = $[3];
    modifiers = $[4];
    props = $[5];
  }
  let t1;
  if ($[6] !== day.date || $[7] !== locale?.code) {
    t1 = day.date.toLocaleDateString(locale?.code);
    $[6] = day.date;
    $[7] = locale?.code;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const t2 = modifiers.selected || undefined;
  const t3 = modifiers.disabled || undefined;
  const t4 = modifiers.today || undefined;
  const t5 = modifiers.outside || undefined;
  const t6 = modifiers.range_start || undefined;
  const t7 = modifiers.range_end || undefined;
  const t8 = modifiers.range_middle || undefined;
  let t9;
  if ($[9] !== className) {
    t9 = cn("relative z-20 inline-flex items-center justify-center size-[46px] rounded-full p-0 cursor-pointer", "typography-component-xs-medium tracking-[-0.28px]", "text-text-primary transition-colors", "hover:bg-surface-base-secondary", "data-[selected=true]:bg-button-primary-background data-[selected=true]:text-white", "data-[disabled=true]:text-text-disabled data-[disabled=true]:pointer-events-none", "data-[outside=true]:text-text-disabled", "data-[today=true]:font-bold", "data-[range-middle=true]:rounded-none data-[range-middle=true]:bg-surface-base-secondary data-[range-middle=true]:text-text-primary", "data-[range-start=true]:rounded-s-full", "data-[range-end=true]:rounded-e-full", className);
    $[9] = className;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== props || $[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7 || $[19] !== t8 || $[20] !== t9) {
    t10 = <button type="button" data-day={t1} data-selected={t2} data-disabled={t3} data-today={t4} data-outside={t5} data-range-start={t6} data-range-end={t7} data-range-middle={t8} className={t9} {...props} />;
    $[11] = props;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}
type CalendarProps = React.ComponentProps<typeof DayPicker>;
const Calendar = React.forwardRef<HTMLDivElement, CalendarProps>((t0, ref) => {
  const $ = _c(56);
  let className;
  let classNames;
  let components;
  let formatters;
  let locale;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      classNames,
      showOutsideDays: t1,
      captionLayout: t2,
      locale,
      formatters,
      components,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = classNames;
    $[3] = components;
    $[4] = formatters;
    $[5] = locale;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
  } else {
    className = $[1];
    classNames = $[2];
    components = $[3];
    formatters = $[4];
    locale = $[5];
    props = $[6];
    t1 = $[7];
    t2 = $[8];
  }
  const showOutsideDays = t1 === undefined ? true : t1;
  const captionLayout = t2 === undefined ? "label" : t2;
  let t3;
  if ($[9] !== className) {
    t3 = cn("w-full bg-white p-6 rounded-lg", className);
    $[9] = className;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== locale?.code) {
    t4 = date => date.toLocaleString(locale?.code, {
      month: "short"
    });
    $[11] = locale?.code;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== formatters || $[14] !== t4) {
    t5 = {
      formatMonthDropdown: t4,
      ...formatters
    };
    $[13] = formatters;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  let t21;
  let t22;
  let t23;
  let t24;
  let t25;
  let t26;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = cn("relative");
    t7 = cn("flex flex-col gap-6");
    t8 = cn("flex flex-col gap-2");
    t9 = cn("flex items-center justify-center relative py-1", "typography-component-md-medium text-text-primary");
    t10 = cn("whitespace-nowrap");
    t11 = cn("absolute inset-x-6 top-6 z-10 flex items-center justify-between");
    t12 = cn("size-6 flex items-center justify-center text-text-primary hover:text-text-secondary transition-colors cursor-pointer", "disabled:text-text-disabled disabled:pointer-events-none");
    t13 = cn("size-6 flex items-center justify-center text-text-primary hover:text-text-secondary transition-colors cursor-pointer", "disabled:text-text-disabled disabled:pointer-events-none");
    t14 = cn("flex w-full pt-6 pb-4");
    t15 = cn("flex-1 text-center typography-component-xs-medium text-text-secondary");
    t16 = cn("flex flex-col gap-1");
    t17 = cn("flex w-full");
    t18 = cn("flex-1 flex items-center justify-center relative", "[&:last-child[data-selected=true]_button]:rounded-e-full", "[&:first-child[data-selected=true]_button]:rounded-s-full");
    t19 = cn("rounded-s-full", "relative after:absolute after:inset-y-0 after:end-0 after:w-1/2 after:bg-surface-base-secondary after:-z-10");
    t20 = cn("rounded-e-full", "relative after:absolute after:inset-y-0 after:start-0 after:w-1/2 after:bg-surface-base-secondary after:-z-10");
    t21 = cn("");
    t22 = cn("");
    t23 = cn("");
    t24 = cn("");
    t25 = cn("");
    t26 = cn("invisible");
    $[16] = t10;
    $[17] = t11;
    $[18] = t12;
    $[19] = t13;
    $[20] = t14;
    $[21] = t15;
    $[22] = t16;
    $[23] = t17;
    $[24] = t18;
    $[25] = t19;
    $[26] = t20;
    $[27] = t21;
    $[28] = t22;
    $[29] = t23;
    $[30] = t24;
    $[31] = t25;
    $[32] = t26;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
  } else {
    t10 = $[16];
    t11 = $[17];
    t12 = $[18];
    t13 = $[19];
    t14 = $[20];
    t15 = $[21];
    t16 = $[22];
    t17 = $[23];
    t18 = $[24];
    t19 = $[25];
    t20 = $[26];
    t21 = $[27];
    t22 = $[28];
    t23 = $[29];
    t24 = $[30];
    t25 = $[31];
    t26 = $[32];
    t6 = $[33];
    t7 = $[34];
    t8 = $[35];
    t9 = $[36];
  }
  let t27;
  if ($[37] !== classNames) {
    t27 = {
      root: t6,
      months: t7,
      month: t8,
      month_caption: t9,
      caption_label: t10,
      nav: t11,
      button_previous: t12,
      button_next: t13,
      weekdays: t14,
      weekday: t15,
      weeks: t16,
      week: t17,
      day: t18,
      range_start: t19,
      range_end: t20,
      range_middle: t21,
      selected: t22,
      today: t23,
      outside: t24,
      disabled: t25,
      hidden: t26,
      ...classNames
    };
    $[37] = classNames;
    $[38] = t27;
  } else {
    t27 = $[38];
  }
  let t28;
  if ($[39] !== locale) {
    t28 = t29 => {
      const {
        ...buttonProps
      } = t29;
      return <CalendarDayButton locale={locale} {...buttonProps} />;
    };
    $[39] = locale;
    $[40] = t28;
  } else {
    t28 = $[40];
  }
  let t29;
  if ($[41] !== components || $[42] !== t28) {
    t29 = {
      DayButton: t28,
      Chevron: _temp,
      ...components
    };
    $[41] = components;
    $[42] = t28;
    $[43] = t29;
  } else {
    t29 = $[43];
  }
  let t30;
  if ($[44] !== captionLayout || $[45] !== locale || $[46] !== props || $[47] !== showOutsideDays || $[48] !== t27 || $[49] !== t29 || $[50] !== t3 || $[51] !== t5) {
    t30 = <DayPicker showOutsideDays={showOutsideDays} className={t3} captionLayout={captionLayout} locale={locale} formatters={t5} classNames={t27} components={t29} {...props} />;
    $[44] = captionLayout;
    $[45] = locale;
    $[46] = props;
    $[47] = showOutsideDays;
    $[48] = t27;
    $[49] = t29;
    $[50] = t3;
    $[51] = t5;
    $[52] = t30;
  } else {
    t30 = $[52];
  }
  let t31;
  if ($[53] !== ref || $[54] !== t30) {
    t31 = <div ref={ref} data-slot="calendar">{t30}</div>;
    $[53] = ref;
    $[54] = t30;
    $[55] = t31;
  } else {
    t31 = $[55];
  }
  return t31;
});
Calendar.displayName = "Calendar";
export { Calendar };
export type { CalendarProps };
function _temp(t0) {
  const {
    orientation
  } = t0;
  if (orientation === "left") {
    return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>;
  }
  return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>;
}